import * as t from "io-ts";
import { CustomFontFamilyV } from "@/types/custom-fonts";
import { BreakpointV } from "./breakpoints";

export const PreferencesV = t.type({
  customFonts: t.array(CustomFontFamilyV),
  customBreakpoints: t.array(BreakpointV)
});

export type Preferences = t.TypeOf<typeof PreferencesV>;
